// extracted by mini-css-extract-plugin
module.exports = {"file":"EventFilesSection_file__2Wh1a","fileIcon":"EventFilesSection_fileIcon__20uYP"};